__webpack_require__.p = "https://prd.static.uploader-widget.video.wds.io/";